import React, { useEffect, } from 'react';
import './Student.css';
import topImage01 from '../assets/images/student/student-image-top.jpeg';
import { useLocation } from 'react-router-dom';
import Typewriter from './Typewriter';
import StudentCampaignSection from './StudentCampaignSection';
import AiFeatureSection from './AiFeatureSection';
import StudentFeaturesSection from './StudentFeaturesSection';
import OpenSchoolSection from './OpenSchoolSection';
import StudentFutureSection from './StudentFutureSection';
import StudentCourseDetailSection from './StudentCourseDetailSection';
import StudentCourseCommonSection from './StudentCourseCommonSection';
import StudentLearningPlanSection from './StudentLearningPlanSection';

const Student = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }
  }, [hash]);

  return (
    <div className="student">
      <div className="student-page-title">
        <div className='student-image-container'>
			<h1 className='student-image-text cyber-link'>
			{/* 1行目：カーソルは完了後消える */}
				<Typewriter text="好きな仕事で" speed={80} />

				<br />

				{/* 2行目：開始を遅らせる、完了後もカーソル残す */}
				<Typewriter text="自由に働く" speed={80} startDelay={900} keepCursor />
			</h1>

          {/* <p className='student-image-text-p'>第一期生 募集中！</p> */}
          <img src={topImage01} alt="学習内容" className="student-top-image" />
        </div>
      </div>

      {/* <section id="student-campaign-section">
        <StudentCampaignSection />
      </section> */}

	  <section id="ai-feature-section">
        <AiFeatureSection />
      </section>

	  <section id="student-features-section">
        <StudentFeaturesSection />
      </section>

	　<section id="open-school-section">
        <OpenSchoolSection />
      </section>

	　<section id="student-future-section">
        <StudentFutureSection />
      </section>

	　<section id="student-course-detail-section">
        <StudentCourseDetailSection />
      </section>

	　<section id="student-course-common-section">
        <StudentCourseCommonSection />
      </section>

	　<section id="student-learning-plan-section">
        <StudentLearningPlanSection />
      </section>

</div>
  );
};

export default Student;
